<template>
   <div :class="['content', { 'flex_row' : isRow }]" :style="`padding-bottom:${paddingBottom}`">
     <slot></slot>
   </div>
</template>
<script>
export default {
  props: {
    // 横轴
    isRow: {
      type: Boolean,
      default: false
    },
    // 底部内边距
    paddingBottom: {
      type: String,
      default: '0px'
    }
  }
}
</script>
<style lang="scss" scoped>
// 在main组件中使用 充当内容区块
  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
    background:#FFFFFF;
    box-shadow:0px 10px 15px rgba(0,0,0,0.1);
    border-radius:10px;
    padding: 10px 30px 0px 30px;
    overflow: auto;
    &.flex_row {
      flex-direction: row;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/main/content.vue